import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { createFamille, updateFamille } from '@/store/thunks/familleThunks';
import type { Famille } from '@/types';
import { Input, Button } from '@/components/ui';

const schema = Yup.object({
  nom: Yup.string().required('Nom obligatoire'),
});

interface FamilleFormProps {
  famille?: Famille | null;
  type: 'create' | 'update';
  onClose: () => void;
  onSuccess?: () => void;
}

export default function FamilleForm({ famille, type, onClose, onSuccess }: FamilleFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: { nom: famille?.nom ?? '' },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (type === 'update' && famille?.id) {
        const res = await dispatch(updateFamille({ ...famille, ...values }));
        if (updateFamille.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      } else {
        const res = await dispatch(createFamille(values));
        if (createFamille.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <Input label="Nom" id="nom" {...formik.getFieldProps('nom')} error={formik.touched.nom ? formik.errors.nom : undefined} />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
        <Button type="submit" loading={formik.isSubmitting}>{type === 'update' ? 'Modifier' : 'Créer'}</Button>
      </div>
    </form>
  );
}
